import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function ShellFront() {
	return (
		<g>
			<path className="fill" d="M255.3731384,178.2835999
				c70.0317688,0,126.8265076,52.3034668,126.826355,120.3929138c0.0001526,17.3858948-42.9061584,24.4824219-126.8037567,24.4824219
				h-0.0452118c-30.0759888,0-41.4447937-17.3795776-56.0522461-29.8605652
				c-8.1835632-6.992218-29.9604187-30.4655151-44.0357666-30.4655151" />
			<ellipse className="fill fill--dark" transform="matrix(0.945053 -0.326917 0.326917 0.945053 -75.3242264 134.9950256)" cx="363.9267578" cy="291.5751648" rx="7.0994086" ry="7.0994086" />
			<ellipse className="fill fill--dark" transform="matrix(0.945053 -0.326917 0.326917 0.945053 -72.5145645 130.2639923)" cx="351.2575378" cy="280.8513794" rx="4.4301147" ry="4.4301147" />
			<ellipse className="fill fill--dark" transform="matrix(0.945053 -0.326917 0.326917 0.945053 -77.9462967 129.430191)" cx="346.0612488" cy="296.5930176" rx="5.6807146" ry="5.6807146" />
			<ellipse className="fill fill--dark" transform="matrix(0.3609667 -0.9325787 0.9325787 0.3609667 -0.4517455 409.1203613)" cx="298.3007812" cy="204.8898163" rx="7.0994086" ry="7.0994086" />
			<ellipse className="fill fill--dark" transform="matrix(0.3609667 -0.9325787 0.9325787 0.3609667 -13.965313 422.139679)" cx="301.0439148" cy="221.2600403" rx="4.4301147" ry="4.4301147" />
			<ellipse className="fill fill--dark" transform="matrix(0.3609667 -0.9325787 0.9325787 0.3609667 3.1432755 429.7888184)" cx="315.1796265" cy="212.6008301" rx="5.6807146" ry="5.6807146" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/ShellFront.js